import { render, staticRenderFns } from "./TreeNodeDialog.vue?vue&type=template&id=c10ba65c&"
import script from "./TreeNodeDialog.vue?vue&type=script&lang=js&"
export * from "./TreeNodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c10ba65c')) {
      api.createRecord('c10ba65c', component.options)
    } else {
      api.reload('c10ba65c', component.options)
    }
    module.hot.accept("./TreeNodeDialog.vue?vue&type=template&id=c10ba65c&", function () {
      api.rerender('c10ba65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/TreeNodeDialog.vue"
export default component.exports